module.exports = __webpack_public_path__ + "img/course_Image_four.ead8abd9.png";